module.exports = __webpack_public_path__ + "static/media/switch-checked-v2.d3dea9d1.svg";